import type { ReactNode } from 'react';

import styles from '@/admin/components/AdminBadge.module.scss';

type AdminBadgeProps = {
  children: ReactNode;
  tone?: 'neutral' | 'success' | 'danger';
};

const TONE_CLASS = {
  neutral: '',
  success: styles.success,
  danger: styles.danger,
};

export const AdminBadge = ({ children, tone = 'neutral' }: AdminBadgeProps) => (
  <span className={`${styles.badge} ${TONE_CLASS[tone]}`}>{children}</span>
);
